import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchBranchById } from "../../store/branch-slice";
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import { getDetailData } from "../../models/branchModel";
import {getValidatedLimit} from "../../components/Utility";

const BranchDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.branch);
    const {limit, currentPage} = getValidatedLimit(pagination);

    useEffect(() => {
        dispatch(fetchBranchById(params.branchId)); // Adjust based on your actual Redux action
    }, [dispatch, params.branchId]);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.branch); // Adjust based on your Redux slice

    const item = items.find(item => item.id === params.branchId); // Ensure correct id matching
    const detailData = getDetailData({ item }); // Adjust this to fit how you process data for details

    return (
        <>
            <SubHeader title="Branch Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`} className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{ lg: 9, xl: 7 }} data={detailData} />}
            </div>
        </>
    );
};

export default BranchDetail;
